import { mapEntityProperties } from '@/utils/mapEntityProperties'
import { CompaniesFilterEntity } from '../../domain/entities/CompaniesFilterEntity'

export class CompaniesFilterModel extends CompaniesFilterEntity {
  userId?: string
  serviceId?: number

  constructor(dataDto: CompaniesFilterEntity) {
    super()
    mapEntityProperties<CompaniesFilterModel>(this, dataDto, {
      exclude: ['user', 'service'],
      map: {
        userId: dataDto.user?.id,
        serviceId: dataDto.service?.id,
      }
    })
  }
}